export const SHARED_CONSTANTS = {
    CREATE_WITH_DOC_NO_ENDPOINT: 'create_with_doc_no',
    LIST_FIELD_MODULE_COMPONENT_TYPES: ['Tenant', 'User', 'Contact', 'Vendor', 'Role', 'Menu'],
    LIST_FIELD_MODULE_ALL_DATA_COMPONENT_TYPES: ['Role', 'Menu'],
};
